/**
 * A HOC wrapping Material UIs Input Form Control with Label Component.
 * Used to unify the styles across all of our text inputs.
 */
import { get, omit } from 'lodash';
import React from 'react';
import { withStyles } from 'tss-react/mui';
import { FormControl, InputLabel, Input, OutlinedInput } from '@mui/material';
import { P } from '@fashionnovateam/nova-ui-toolkit';

const styles = (theme) => ({
  root: {
    marginRight: '10px',
  },
  label: {
    color: get(theme, 'palette.primary.main'),
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '1px',
    lineHeight: '22px',
    textTransform: 'uppercase',
  },
  field: {
    overflow: 'auto',
    '&::placeholder': {
      fontWeight: 'bold',
    },
    '& input': {
      overflow: 'auto',
    },
  },
});

const TextInput = withStyles((props) => {
  const { classes, label, id, formHelperText, outlined } = props;

  return (
    <FormControl
      variant="standard"
      className={classes.root}
      required={props.required}
      fullWidth={props.fullWidth}
      error={props.error}
    >
      <InputLabel className={classes.label} htmlFor={id}>
        {label}
      </InputLabel>
      {outlined ? (
        <OutlinedInput
          className={classes.field}
          {...omit(
            props,
            'label',
            'classes',
            'required',
            'fullWidth',
            'error',
            'formHelperText',
            'InputLabelProps',
            'outlined',
          )}
        />
      ) : (
        <Input
          className={classes.field}
          {...omit(
            props,
            'label',
            'classes',
            'required',
            'fullWidth',
            'error',
            'InputLabelProps',
            'formHelperText',
          )}
        />
      )}
      <P color="error">{formHelperText}</P>
    </FormControl>
  );
}, styles);

export default TextInput;
